import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';

@customElement('visual-lightengine')
export class VisualLightengine extends LitElement {

	static styles = css`
	  :host {
		display: flex;
	  }
	`;

	@property({type: Object})
	section = {};

	render() {
		return html`
			<svg-productimage></svg-productimage>
		`;
	}
}
